import React from "react";

import Button from "../../components/Button";
import Collaborators from "../../components/Collaborators";
import Container from "../../components/Container";
import ContainerDivider from "../../components/ContainerDivider";
import Icon from "../../components/Icon";
import PublicNavbar from "../../components/PublicNavbar";
import Spacer from "../../components/Spacer";
import TextField from "../../components/TextField";
import Textarea from "../../components/Textarea";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import submitSupport from "../../helpers/submitSupport";
import { useForm } from "react-hook-form";

type Inputs = {
  email: string;
  name: string;
  subject: string;
  message: string;
};

const Support = () => {
  const { register, handleSubmit, errors, formState } = useForm<Inputs>({
    mode: "onChange",
  });

  const onSubmit = (data: Inputs) => {
    submitSupport(data.email, data.name, data.subject, data.message);
  };

  return (
    <div className="SupportPage">
      <PublicNavbar />

      <Container>
        <div className="space-y-8">
          <div className="w-full">
            <div className="my-4 text-lg font-medium text-aqua">Find Help</div>
            <div className="my-4 text-5xl font-bold leading-none">
              Customer Support
            </div>
          </div>

          <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="flex space-x-4">
              <TextField
                type="email"
                name="email"
                placeholder="Email Address"
                register={register({
                  required: "Required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9]{2,}$/i,
                    message: "Invalid email address.",
                  },
                })}
                error={errors.email?.message}
              />
              <TextField
                type="text"
                name="name"
                placeholder="Name"
                register={register({
                  required: "Required",
                })}
                error={errors.name?.message}
              />
            </div>
            <TextField
              type="text"
              name="subject"
              placeholder="Subject"
              register={register({
                required: "Required",
              })}
              error={errors.subject?.message}
            />
            <Textarea
              name="message"
              placeholder="Write message..."
              register={register({
                required: "Required",
              })}
              error={errors.message?.message}
            />
            <Button
              type="submit"
              disabled={!formState.isValid}
              isLoading={formState.isSubmitting}
            >
              Submit
            </Button>
          </form>
          {formState.isSubmitted ? (
            <div className="w-full my-2 text-sm text-green-600">
              <Icon icon={faCheck} /> Submitted message successfully. We will
              get back to you as soon as possible. Thank you.
            </div>
          ) : null}
        </div>
      </Container>

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>
    </div>
  );
};

export default Support;
